import { UserRoles } from '../user-roles';
import { z } from 'zod';

export const emailSchema = z.string().email();

export const userSchema = z.object({
  email: emailSchema,
  role: z.enum([UserRoles.MANAGER, UserRoles.USER]),
});

export const inviteTeamSchema = z
  .object({
    isMultiEntryMode: z.boolean(),
    singleEntryUserRole: z.enum([UserRoles.MANAGER, UserRoles.USER]).optional(),
    email: z.string().optional(),
    users: z.array(userSchema),
  })
  .superRefine((val, ctx) => {
    if (val.isMultiEntryMode) {
      const email = (val.email ?? '')
        .split(',')
        .map((part) => part.trim())
        .filter((part) => part.length > 0);

      const userEmails = val.users.map((e) => e.email);

      const uniqueEmails = new Set([...email, ...userEmails]);

      if (uniqueEmails.size !== [...email, ...userEmails].length) {
        ctx.addIssue({
          path: ['email'],
          code: z.ZodIssueCode.custom,
          message: 'Duplicate entries present',
        });
        return;
      }

      const isValidEmails = email.every((email) => emailSchema.safeParse(email).success);
      if (!isValidEmails) {
        ctx.addIssue({
          path: ['email'],
          code: z.ZodIssueCode.custom,
          message: 'One or more email are invalid',
        });
        return;
      }

      const totalEmails = email.length + val.users.length;
      if (totalEmails > 10) {
        ctx.addIssue({
          path: ['email'],
          code: z.ZodIssueCode.custom,
          message: 'Maximum 10 entries*',
        });
      }
    } else {
      if (val.email?.length === 0) {
        ctx.addIssue({
          path: ['email'],
          code: z.ZodIssueCode.custom,
          message: 'Email is required',
        });
        return;
      }
      const isValidEmail = emailSchema.safeParse(val.email).success;
      if (!isValidEmail) {
        ctx.addIssue({
          path: ['email'],
          code: z.ZodIssueCode.custom,
          message: 'Please enter a valid email address',
        });
        return;
      }
    }
  });

export type InvitedTeamMemberModel = z.infer<typeof userSchema>;

export type InviteTeamFormModel = z.infer<typeof inviteTeamSchema>;